import { graphql, useFragment, useMutation } from 'react-relay';

import withSuspense from '../../../hocs/withSuspense';
import useEnumPairsQuery from '../../../hooks/useEnumPairsQuery';
import {
  MATSalesRecordPriorityEnum,
  MATSalesRecordPriorityUpdateActionList_matSalesRecord$key,
} from '../../../relay/__generated__/MATSalesRecordPriorityUpdateActionList_matSalesRecord.graphql';
import { MATSalesRecordPriorityUpdateActionList_salesRecordUpdateMutation } from '../../../relay/__generated__/MATSalesRecordPriorityUpdateActionList_salesRecordUpdateMutation.graphql';
import ActionList, { ActionListProps, ActionListItemProps } from '../../core/ActionList';

const MATSalesRecordPriorityUpdateActionList_matSalesRecord = graphql`
  fragment MATSalesRecordPriorityUpdateActionList_matSalesRecord on MATSalesRecord {
    id
    priority
  }
`;

type Props = {
  matSalesRecord: MATSalesRecordPriorityUpdateActionList_matSalesRecord$key;
} & Pick<ActionListItemProps, 'onSelect'> &
  ActionListProps;

const MATSalesRecordPriorityUpdateActionList = ({ matSalesRecord, onSelect, ...props }: Props) => {
  const { id, priority } = useFragment(MATSalesRecordPriorityUpdateActionList_matSalesRecord, matSalesRecord);
  const [mutate] = useMutation<MATSalesRecordPriorityUpdateActionList_salesRecordUpdateMutation>(graphql`
    mutation MATSalesRecordPriorityUpdateActionList_salesRecordUpdateMutation($input: MATSalesRecordUpdateInput!) {
      salesRecordUpdate(input: $input) {
        id
        ...MATSalesRecordPriorityUpdateActionList_matSalesRecord
      }
    }
  `);

  const enumPairs = useEnumPairsQuery('MATSalesRecordPriorityEnum');

  return (
    <ActionList {...props} selectionVariant={'single'}>
      {enumPairs.map(({ key, value }) => (
        <ActionList.Item
          key={key}
          selected={key === priority}
          onSelect={(e) => {
            mutate({ variables: { input: { id, priority: key as MATSalesRecordPriorityEnum } } });
            onSelect?.(e);
          }}
        >
          {value}
        </ActionList.Item>
      ))}
    </ActionList>
  );
};

export default withSuspense(MATSalesRecordPriorityUpdateActionList);
